var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBorder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64.02845001220703,
    height: 16.24336752741422,
    viewBox: "0 0 64.02845001220703 16.24336752741422",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear_0",
    x1: "12.192451862722464%",
    y1: "50%",
    x2: "94.02314857269936%",
    y2: "85.46050521743638%",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0017,
    stopColor: "#645CFF",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB8061",
    stopOpacity: 1
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "left",
    fillRule: "evenodd",
    fill: "url(#linear_0)",
    transform: "translate(0 0)  rotate(0 32.014225006103516 8.12168376370711)",
    opacity: 1,
    d: "M18.0454 16.24L7.17538 16.24L-0.00462392 0L10.8654 0L18.0454 16.24Z M25.228 16.24L20.868 16.24L13.688 0L18.048 0L25.228 16.24Z M50.7925 16.24L28.9225 16.24L21.7425 0L43.6125 0L50.7925 16.24Z M59.5949 16.24L55.9049 16.24L48.7249 0L52.4149 0L59.5949 16.24Z M64.0258 16.24L61.9458 16.24L54.7658 0L56.8458 0L64.0258 16.24Z "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorder);
export default __webpack_public_path__ + "static/media/border.e9d08b40bee4a54711f0efaf69a33e73.svg";
export { ForwardRef as ReactComponent };